// This file is automatically generated. Do not edit manually.

import { FrontendDownloadFileHandle } from "src/api/generated/common/frontendDownloadFileHandle";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace WiivakalusteShopOrderBatchApi {
	export async function exportSawImportFile(args: {
		shopOrderBatchIds: Array<number>;
	}): Promise<Array<FrontendDownloadFileHandle>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/production/wiivakaluste/shopOrderBatch/exportSawImportFile",
			method: "POST",
			data: {
				shopOrderBatchIds: args.shopOrderBatchIds,
			},
		});
		return response as Array<FrontendDownloadFileHandle>;
	}
}
